import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=6ebafa64&scoped=true"
import script from "./BaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=6ebafa64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebafa64",
  null
  
)

export default component.exports